import React from 'react';
import useStyle from './loadingLayout.style';
import { classNames } from 'helpers/style/classNames';
import logo from '../../../../assets/loading/loaderlogo.svg';

interface LoadingLayoutProps {
  variant?: 'default' | 'centeredOnly';
}

export const LoadingLayout = ({ variant = 'default' }: LoadingLayoutProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root],
        [
          {
            condition: variant === 'default',
            classe: classes.default
          }
        ]
      )}
    >
      <img
        className={classes.imageChargement}
        src={logo}
        alt="Logo de chargement"
      />
    </div>
  );
};
